import { create } from 'zustand';

type ExportUiState = {
  exporting: boolean;
  setExporting: (exporting: boolean) => void;
};

export const useExportUiStore = create<ExportUiState>((set) => ({
  exporting: false,
  setExporting: (exporting) => set({ exporting }),
}));
